/**
 * Controls the pre-boot loader markup in `src/app.html`.
 *
 * The loader lives outside the SvelteKit container so it survives until the app
 * explicitly tears it down. With `ssr = false` the root layout renders nothing
 * while its `load` resolves the session, and on the login handoff that `load`
 * never resolves at all — the loader covers both gaps.
 */
const LOADER_ID = 'app-loading';
const MESSAGE_ID = 'app-loading-message';

/** Update the text under the spinner without tearing the loader down. */
export const setAppLoaderMessage = (message: string): void => {
	const element = document.getElementById(MESSAGE_ID);
	if (element) element.textContent = message;
};

/** Fade out and remove the loader. Safe to call more than once. */
export const hideAppLoader = (): void => {
	const loader = document.getElementById(LOADER_ID);
	if (!loader) return;
	loader.style.opacity = '0';
	loader.style.pointerEvents = 'none';
	setTimeout(() => loader.remove(), 250);
};
